import Page from '@pelckmans/elementis/components/page';
import Tabs from '@pelckmans/elementis/components/tabs';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import AllAssignments from './components/Assignments';
import ContentHeader from '../../../layout/content/ContentHeader';
import ContentBody from '../../../layout/content/ContentBody';
import ModuleBreadcrumbs from '../../../layout/header/ModuleBreadcrumbs';
import {
  withScrollThreshold,
  WithScrollThresholdProps,
} from '../../../shared-components/elementis/hoc/withScrollThreshold';

const TABS = {
  TO_MAKE: 'TO_MAKE',
  FINISHED: 'FINISHED',
};

interface AssignmentsProps extends WithScrollThresholdProps {}

function Assignments({ pastThreshold }: AssignmentsProps) {
  const { t } = useTranslation();

  useDocumentTitle(t('PAGES.ASSIGNMENTS.DOCUMENT_TITLE'));

  return (
    <Page>
      <Tabs>
        <ContentHeader
          cover={
            <Page.Header
              density={pastThreshold ? 'compact' : 'normal'}
              breadcrumbs={<ModuleBreadcrumbs size={pastThreshold ? 'sm' : 'md'} />}
              headerText={t('PAGES.ASSIGNMENTS.PAGE_TITLE')}
              extra={
                <Tabs.TabList
                  aria-label={t('PAGES.ASSIGNMENTS.TAB_LIST.A11Y_LABEL')}
                  size={pastThreshold ? 'sm' : 'md'}
                >
                  <Tabs.Tab id={TABS.TO_MAKE}>{t('PAGES.ASSIGNMENTS.STUDENT.TAB_LIST.TABS.TO_MAKE')}</Tabs.Tab>
                  <Tabs.Tab id={TABS.FINISHED}>{t('PAGES.ASSIGNMENTS.STUDENT.TAB_LIST.TABS.FINISHED')}</Tabs.Tab>
                </Tabs.TabList>
              }
            />
          }
        />
        <ContentBody>
          <div className="assignments-section">
            <Tabs.TabsContent>
              <Tabs.TabPanel id={TABS.TO_MAKE}>
                <AllAssignments />
              </Tabs.TabPanel>
              <Tabs.TabPanel id={TABS.FINISHED}>
                <>afgelopen taken</>
              </Tabs.TabPanel>
            </Tabs.TabsContent>
          </div>
        </ContentBody>
      </Tabs>
    </Page>
  );
}

export default withScrollThreshold(Assignments);
